// extracted by mini-css-extract-plugin
module.exports = {"container":"SideNavigationBottom_container__1UQE5","hide_on_desktop":"SideNavigationBottom_hide_on_desktop__1u9Z8"};